import { CalendlyPointOfEntry } from "../../../constants/posthogEventContextTypes";
import { useSetCalendlyScheduledAt } from "../../../hooks/api/useSetCalendlyScheduledAt";
import { Event, EventTracker } from "../../../tracking/service/EventTracker/EventTrackerService";
import { useRedirect } from "../Common/hooks/useRedirect";
import { useRegistrationContext } from "../Common/registrationContext";
import { saveRegistrationContextToLocalStorage } from "../Common/service";

export const useCalendlyViewProps = (shiftPreview: boolean) => {
  const { registrationContext, setRegistrationContext } = useRegistrationContext();
  const { redirectToReferral } = useRedirect();
  const { mutate: setScheduledAt } = useSetCalendlyScheduledAt();

  const sendScheduledTrackingEvent = (shiftPreview: boolean, vetId: number) => {
    EventTracker.send({
      eventName: Event.Name.VET_SCHEDULE_ACTIVATION_CALL_COMPLETE,
      eventType: Event.Type.CLICK,
      entityType: Event.Entity.VET,
      entityId: vetId,
      context: {
        pointOfEntry: shiftPreview ? CalendlyPointOfEntry.RegistrationMeetYourRooRep : undefined,
      },
    });
  };

  const onEventScheduled = () => {
    setRegistrationContext({
      ...registrationContext,
      registrationContext: {
        ...registrationContext,
        isCalendlyButtonDisabled: false,
      },
    });

    sendScheduledTrackingEvent(shiftPreview, registrationContext.entityId);

    setScheduledAt({
      vetId: registrationContext.entityId,
      scheduledAt: new Date().toISOString(),
    });

    // TODO: Do we really need to send this as well? Seems like we were sending two events when a call was scheduled.
    EventTracker.send({
      eventName: Event.Name.CALENDLY_EVENT_SCHEDULED,
      eventType: Event.Type.IMPRESSION,
      entityType: Event.Entity.VET,
      entityId: registrationContext.entityId,
    });
    saveRegistrationContextToLocalStorage(registrationContext);
    redirectToReferral();
  };

  const onDateAndTimeSelected = () => {
    EventTracker.send({
      eventName: Event.Name.CALENDLY_DATE_AND_TIME_SELECTED,
      eventType: Event.Type.CLICK,
      entityType: Event.Entity.VET,
      entityId: registrationContext.entityId,
    });
  };
  const onProfilePageViewed = () => {
    EventTracker.send({
      eventName: Event.Name.CALENDLY_PROFILE_PAGE_VIEWED,
      eventType: Event.Type.CLICK,
      entityType: Event.Entity.VET,
      entityId: registrationContext.entityId,
    });
  };
  const onEventTypeViewed = () => {
    EventTracker.send({
      eventName: Event.Name.CALENDLY_EVENT_TYPE_VIEWED,
      eventType: Event.Type.CLICK,
      entityType: Event.Entity.VET,
      entityId: registrationContext.entityId,
    });
  };
  return { onEventScheduled, onDateAndTimeSelected, onProfilePageViewed, onEventTypeViewed };
};
